import { useEffect, useState } from 'react';
import CampoObrigatorio from '../CampoObrigatorio/CampoObrigatorio';
import './InputSelectPadrao.css';
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { IoClose } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';


function InputSelectPadrao({
    className,
    onChange, 
    titulo, 
    obrigatorio, 
    icone,
    name, 
    placeholder, 
    inputPara,
    options,
    extra,
    comErro,
    valorInicial,
    sendAll,
    resetaFiltro
}) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(valorInicial !== undefined ? valorInicial : "");
    const [limpa, setLimpa] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen)
    };

    useEffect(() => {
        if(resetaFiltro !== undefined) {
            setSelectedValue("");
            onChange(inputPara, "");
        }

        setIsOpen(false);
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetaFiltro, limpa]);

    const handleOptionClick = (value) => {
        const descricaoTraduzida = getDescricaoOpcao(inputPara, value); // retorna a chave de tradução
        setSelectedValue(descricaoTraduzida); // salva a chave de tradução no estado `selectedValue`
    
        if (onChange) {
            let opcaoCompleta;
            if (extra !== undefined) {
                for (let index = 0; index < extra.length; index++) {
                    const opcao = extra[index];
                    
                    if (opcao.departamento.idDepartamento === value.id) {
                        opcaoCompleta = opcao;
                        break;
                    }
                }
            } else {
                opcaoCompleta = value;
            }
    
            if (sendAll) {
                onChange(inputPara, value);
            } else {
                onChange(inputPara, opcaoCompleta);
            }
        }
        setIsOpen(false);
    };
    

    const getDescricaoOpcao = (tipo, opcao) => {
        console.log(opcao);
        if(tipo === "situacaoCadastro") {
            return "situacao-" + opcao.idSituacaoCadastro
        }else if (tipo === "perfilUsuario") {
            return "descricao-" + opcao.idPerfilUsuario
        }

        return opcao.descricao
    }

    return (
        <div className={`container-input-select-padrao ${name} ${className}`}>
            <div className="container-label-input-select-padrao">
                {titulo && (
                    <div className="principais-input-select-padrao">
                        {icone && icone}
                        <label htmlFor={name}> {titulo} </label>

                        {(obrigatorio) && (
                            <div className="container-obrigatorio-input-select-padrao">
                                <CampoObrigatorio />
                            </div>
                        )}
                    </div>
                    )}
            </div>

            <div className="select-padrao-container" 
                onClick={toggleDropdown}>

                    <div className={`input-select-padrao-estilo ${comErro ? "erro-invalido" : ""} ${isOpen ? 'open' : ''} ${selectedValue !== "" ? "selecionado" : ''}`}>
                        {selectedValue ? t(selectedValue) : (placeholder ? placeholder : t("selecione-opcao"))}
                        {selectedValue && <IoClose
                            className="close-icon-input-select"
                            onClick={() => {
                                setLimpa(!limpa);
                            }}
                        />}
                        {isOpen ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </div>


                {isOpen && (
                    <div className="dropdown-options-container">
                        {options.map((option, index) => (
                            <div 
                                key={index}
                                className="dropdown-option"
                                onClick={() => handleOptionClick(option)}
                            >
                                {t(getDescricaoOpcao(inputPara, option))}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default InputSelectPadrao;